<template>
  <div :class="modal ? 'modal is-active' : 'modal'">
    <div class="modal-background"></div>
    <div class="modal-card is-small">
      <header class="modal-card-head">
        <button @click="closeModal()" class="delete" aria-label="close"></button>
        <p class="modal-card-title">PLEASE LOGIN TO PROCEED</p>
      </header>
      <section class="modal-card-body has-text-centered ph15">
        <img src="@/assets/img/icon-basket.svg" alt="Basket" class="mt20 mb20" />
        <p class="sub-title is-size-14">Your are not loggedin, Please click on login to proceed.</p>
      </section>
      <footer class="modal-card-foot">
        <div class="next-prev-button">
          <button
            @click.prevent="showLoginModal()"
            class="button is-large is-primary is-full-width"
          >Login</button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { setTimeout } from "timers";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "UserNotLoggedIn",
  data() {
    return {
      modal: false,
      confirmStep: 1
    };
  },

  mounted() {
    bus.$on("show-modal-user-not-loggedin-product-detail", payload => {
      this.modal = payload;
    });
  },

  beforeDestroy() {
    bus.$off('show-modal-user-not-loggedin-product-detail');
  },

  methods: {
    closeModal() {
      this.modal = false;
    },
    showLoginModal() {
      this.closeModal();
      this.va_setLoginModal(true);
    },
    ...mapActions({
      va_setLoginModal: "loginmodal/setModal",
    })
  }
};
</script>